import React, { useState } from 'react';
import { Button } from 'antd';
import { MessageOutlined, MinusOutlined, FullscreenOutlined, ShrinkOutlined } from '@ant-design/icons';

// The external URL provided by the user
const CHATBOT_URL = 'https://data-platform.cds-probono.eu/chat/';

/**
 * Renders a floating chatbot widget.
 * TEMPORARY BEHAVIOR: Currently, clicking the icon redirects to the chatbot URL in a new tab.
 * The complex window logic is commented out until partner fixes are complete.
 */
const ChatbotWidget = () => {
  /*
  // --- TEMPORARILY COMMENTED OUT WIDGET STATE AND HANDLERS ---
  const [size, setSize] = useState('ICON'); // ICON | EXPANDED | MAXIMIZED

  const handleMinimize = () => setSize('ICON');
  const handleMaximize = () => setSize('MAXIMIZED');
  const handleRestore = () => setSize('EXPANDED');
  
  const handleToggle = () => {
    setSize(prev => (prev === 'ICON' ? 'EXPANDED' : 'ICON'));
  };
  // -------------------------------------------------------------
  */

  // -----------------------------------------------------------------------
  // NEW TEMPORARY HANDLER: Redirects to the chatbot in a new tab
  // -----------------------------------------------------------------------
  const handleRedirect = () => {
    window.open(CHATBOT_URL, '_blank');
  };

  // -----------------------------------------------------------------------
  // Dynamic Styles (Simplified to only ICON size for temporary usage)
  // -----------------------------------------------------------------------
  const getWidgetStyles = () => {
    const baseStyle = {
      position: 'fixed',
      bottom: 20,
      right: 20,
      transition: 'all 0.3s ease-in-out',
      zIndex: 1000, 
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      backgroundColor: 'transparent',
      overflow: 'visible',
      border: 'none',
      borderRadius: '50%',
      // These are the dimensions for the floating icon
      width: '60px',
      height: '60px',
    };

    /* // Commenting out the original size logic 
    switch (size) {
      case 'ICON': 
      // ... original ICON styles ...
      case 'EXPANDED':
      // ... original EXPANDED styles ...
      case 'MAXIMIZED':
      // ... original MAXIMIZED styles ...
    }
    */
    
    return baseStyle;
  };

  // -----------------------------------------------------------------------
  // Renderers
  // -----------------------------------------------------------------------

  const renderIconView = () => (
    <Button
      type="primary"
      shape="circle"
      size="large"
      icon={<MessageOutlined style={{ fontSize: '24px' }} />}
      // 1. **THE CHANGE**: Use the handleRedirect function
      onClick={handleRedirect}
      style={{
        width: '60px',
        height: '60px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
      }}
    />
  );

  /*
  // --- TEMPORARILY COMMENTED OUT WINDOW RENDERING LOGIC ---
  const renderWindowView = () => {
    const headerHeight = 40; 
    return (
      <>
        // ... (Header/Control Bar JSX) ...
        <iframe
          src={CHATBOT_URL}
          style={{
            width: '100%',
            height: `calc(100% - ${headerHeight}px)`, 
            border: 'none',
          }}
          title="Pro Bono Chatbot"
          allow="microphone; geolocation"
        />
      </>
    );
  };
  // -------------------------------------------------------------
  */

  return (
    <div style={getWidgetStyles()}>
      {/* 2. **THE CHANGE**: Always render only the icon view */}
      {renderIconView()} 
    </div>
  );
};

export default ChatbotWidget;